export const VERIFY_SELECT_MAIN = 'verify_select_main';
export const VERIFY_SELECT_SUCCESS = 'verify_select_success';

export const STEPS = [VERIFY_SELECT_MAIN, VERIFY_SELECT_SUCCESS];
